import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DistrictMaintenanceRoutingModule } from './district-maintenance-routing.module';
import { DistrictMaintenanceComponent } from './district-maintenance.component';
import { DistrictMaintenanceFormComponent } from './district-maintenance-form/district-maintenance-form.component';
import { DistrictMaintenanceFilterComponent } from './district-maintenance-filter/district-maintenance-filter.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { GenericDropdownModule } from 'src/app/core/custom-modules/dropdowns/generic-dropdown/generic-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    GenericDropdownModule,
    DistrictMaintenanceRoutingModule
  ],
  declarations: [DistrictMaintenanceComponent, DistrictMaintenanceFormComponent, DistrictMaintenanceFilterComponent],
  entryComponents: [DistrictMaintenanceFilterComponent]
})
export class DistrictMaintenanceModule { }
